import { ApiType } from "@gymflow/common";
import { ApiListResponse, ProductCategoryDTO } from "@gymflow/types";
import { useQuery, UseQueryOptions } from "@tanstack/react-query";

import { defaultPage } from "../defaultPage";
import { productQueryKeys } from "./productQueryKeys";

export function useProductCategorySearchList(
  {
    api,
    opts,
    enabled,
  }: {
    api: ApiType;
    opts: Parameters<ApiType["productApi"]["findCategories"]>[0];
    enabled?: boolean;
  },
  queryOpts?: Omit<
    UseQueryOptions<ApiListResponse<ProductCategoryDTO>>,
    "queryKey"
  >,
) {
  return useQuery({
    queryKey: productQueryKeys.categorySearch(opts),
    queryFn: async () => {
      return (await api.productApi.findCategories({ ...opts })).data;
    },
    initialData: defaultPage<ProductCategoryDTO>,
    enabled:
      enabled === undefined
        ? opts.limit !== undefined && opts.page !== undefined
        : enabled,
    ...queryOpts,
  });
}
